import { render } from "./Summary.vue?vue&type=template&id=0ec8280c&scoped=true&lang=pug"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"

import "./Summary.vue?vue&type=style&index=0&id=0ec8280c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec8280c"]])

export default __exports__